import { render, staticRenderFns } from "./user_form.vue?vue&type=template&id=df484ad6&"
import script from "./user_form.vue?vue&type=script&lang=js&"
export * from "./user_form.vue?vue&type=script&lang=js&"
import style0 from "./user_form.vue?vue&type=style&index=0&id=df484ad6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports